<template>
	<div>
		<b-breadcrumb>Channels</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-input v-model="q" placeholder="Search..." @input="loadChannels()" class="mb-2"></b-input>
		<b-table small striped hover :items="channels" :busy="loading>0" :fields="['avatar','name','owner','info','status',{ label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right' }]" :tbody-tr-class="rowClass">
			<template #cell(avatar)="data">
				<b-avatar size="3em" :src="data.item.avatar_url||data.item.service_icon_url" badge-variant=""  badge-offset="-0.4em">
					<template #badge><b-avatar :src="data.item.service_icon_url||null" size="1.3em" class="service_avatar" square :title="data.item.service_name"></b-avatar></template>
				</b-avatar>
			</template>
			<template #cell(name)="data">
				<a :href="data.item.info&&data.item.info.url" target="_blank">{{data.item.title}}</a>
				<b-icon icon="x" variant="danger" v-if="data.item.verification_status != 'verified'"></b-icon><br />
				<code>{{data.item.channel_token}}</code><br />
				<small>{{data.item.service_name}}</small>
			</template>
			<template #cell(owner)="data">
				{{data.item.owner_username}}
			</template>
			<template #cell(info)="data">
				<b-badge pill :variant="data.item.loading > 0 ? 'warning' : (data.item.error ? 'danger' : (data.value.numLive>0?'success':'secondary'))" v-if="data.item.status == 'enabled'" :title="data.value.numLive>0?'live':'offline'" v-b-tooltip.hover>{{typeof data.value.numViewers == 'number' ? data.value.numViewers : '-'}}</b-badge>
			</template>
			<template #cell(actions)="data">
				<b-button-group size="sm">
					<b-button variant="primary" v-b-tooltip.hover.left.v-primary title="Edit channel" @click="editChannel(data.item.user_id, data.item.service_id, data.item.channel_token)"><b-icon icon="pencil"></b-icon></b-button>
					<b-button variant="danger" v-b-tooltip.hover.right.v-danger title="Delete channel" @click="deleteChannel(data.item.user_id, data.item.service_id, data.item.token)"><b-icon icon="trash"></b-icon></b-button>
				</b-button-group>
			</template>
			<template #cell(status)="data">
				{{data.item.status}}
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<b-modal ref="editModal">
			<b-form @submit.stop.prevent="saveChannel" id="channelEditForm" v-if="curChannel">
				<b-form-group label="Service">
					<b-form-input readonly v-model="curChannel.service_name"></b-form-input>
				</b-form-group>
				<b-form-group label="Channel ID">
					<b-form-input v-model="curChannel.token" placeholder="Token" required readonly></b-form-input>
				</b-form-group>
				<b-form-group label="Channel Name">
					<b-form-input v-model="curChannel.title" placeholder="Name" required readonly></b-form-input>
				</b-form-group>
				<b-form-group label="Owner">{{curChannel.username}}</b-form-group>
				<b-form-group label="Status">
					<b-form-checkbox switch v-model="curChannel.verification_status" value="verified" unchecked-value="unverified">Verified</b-form-checkbox>
				</b-form-group>
				<b-form-group label="Session">
					<b-textarea v-model="curChannel.session" placeholder="Session" readonly rows="6"></b-textarea>
				</b-form-group>
			</b-form>
			<b-alert variant="danger" :show="!!channelError">{{channelError}}</b-alert>
			<template #modal-footer="{ ok, cancel }">
				<div class="w-100">
					<div class="float-right">
						<b-spinner v-show="channelLoading>0" small label="Spinning" class="mr-3"></b-spinner>
						<b-button size="sm" variant="success" type="submit" form="channelEditForm" class="mr-2">
							Save
						</b-button>
						<b-button size="sm" @click="cancel()">
							Cancel
						</b-button>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';
import debounce from 'debounce';

export default {
	name: 'channels',
	components: {
		Pager,
	},
	data() { return {
		channels: [],
		error: null,
		loading: 0,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
		serviceId: null,
		curChannel: null,
		channelError: null,
		channelLoading: 0,
		userSuggestions: [],
		userSearching: 0,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.loadChannels();
	},
	watch: {
		'$route': 'loadChannels',
		'q': 'loadChannels',
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage } });
		},
		loadChannels() {
			this.loading++;
			this.error = null;
			this.$api.get('admin/userChannels', { q: this.q||'', limit: this.perPage, skip: this.skip }).then(channels => {
				this.channels = channels.results.map(c => ({ ...c, loading: true }));
				this.total = channels.total;
				Promise.allSettled(channels.results.map(c => c.status == 'enabled' && this.$api.get(`channel/${encodeURIComponent(c.service_id)}/${encodeURIComponent(c.channel_token)}/info`))).then(settled => {
					for(let i = 0; i < settled.length; i++) {
						this.channels[i].loading = false;
						if(settled[i].status == 'fulfilled') {
							this.$set(this.channels[i], 'info', settled[i].value);
							this.$set(this.channels[i], 'error', null);
						} else {
							this.$set(this.channels[i], 'info', null);
							this.$set(this.channels[i], 'error', settled[i].reason);
						}
					}
				});
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
		deleteChannel(service_id, token) {
			this.loading++;
			this.error = null;
			this.$api.delete(`admin/channel/${encodeURIComponent(service_id)}/${encodeURIComponent(token)}`).then(() => {
				this.$bvToast.toast(`Deleted channel`, { title: 'Success', variant: 'success', solid: true });
				this.loadChannels();
			}, err => this.error = err).finally(() => {
				this.loading--;
			});
		},
		async editChannel(user_id, service_id, token) {
			this.$refs.editModal.show();
			try {
				this.channelLoading++;
				this.channelError = null;
				const channel = await this.$api.get(`admin/userChannel/${encodeURIComponent(user_id)}/${encodeURIComponent(service_id)}/${encodeURIComponent(token)}`);
				channel.owner_username = channel.owner_username || '';
				channel.session = JSON.stringify(channel.session);
				this.curChannel = channel;
			} catch(e) {
				this.channelError = e;
			} finally {
				this.channelLoading--;
			}
		},
		saveChannel() {
			this.channelLoading++;
			this.channelError = null;
			this.$api.patch(`admin/userChannel/${encodeURIComponent(this.curChannel.user_id)}/${encodeURIComponent(this.curChannel.service_id)}/${encodeURIComponent(this.curChannel.token)}`, {
				verification_status: this.curChannel.verification_status,
			}).then(() => {
				this.$refs.editModal.hide();
				this.$bvToast.toast('Channel updated', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.loadChannels();
			}, err => this.channelError = err).finally(() => {
				this.channelLoading--;
			});
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return;
			return item.num_users == 0 && 'table-danger text-danger';
		},
		setChannelUser(user) {
			this.curChannel.owner_username = user.username;
			this.curChannel.owner_user_id = user.id;
		},
		clearOwner() {
			this.curChannel.owner_username = '';
			this.curChannel.owner_user_id = null;
		},
		userSearch: debounce(function() {
			this.userSearching++;
			this.userSuggestions = [];
			this.$api
				.get('users', { q: this.curChannel.owner_username })
				.then(results => {
					this.userSuggestions = results.results.map(r => ({ ...r, name: r.name||r.token }));
				}).catch(err => {
					this.userSuggestions = [];
					this.error = err.error;
				}).finally(() => {
					this.userSearching--;
				});
		}, 300),
	},
};
</script>
